import React, { Suspense } from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { store, persistor } from "./Store";
import { PersistGate } from "redux-persist/integration/react";
import Layout from "./layouts/Layout";
import "react-datetime/css/react-datetime.css";
import "react-image-lightbox/style.css";
import "moment/dist/locale/es";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import InitContext from "./context/InitContext";

moment.suppressDeprecationWarnings = true;

// Las fechas salian en ingles en varias pantallas. El idioma de moment es
// global y hasta ahora nadie lo fijaba: se importaba es-mx sin activarlo, y
// tres componentes llamaban moment.locale("es") por su cuenta, uno de ellos
// sin importar ese idioma. Al no encontrarlo, moment se quedaba en ingles
// para toda la aplicacion, asi que el idioma de una vista dependia de que
// pantalla se hubiera montado antes.
moment.locale("es");

const Router = import.meta.env.MODE === "electron" ? HashRouter : BrowserRouter;

const App = () => (
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback="loading">
          <InitContext>
            <Router>
              <Switch>
                <Layout />
              </Switch>
            </Router>
          </InitContext>
        </Suspense>
      </PersistGate>
    </Provider>
  </Sentry.ErrorBoundary>
);

export default App;
